import { Controller } from "@hotwired/stimulus"
import { debounce } from "../../../utils"

export default class extends Controller {
  static targets = ["buyerId", "newBuyer", "newBuyerName", "query", "results", "selected", "selectedName"]
  static values = { url: String }

  cancelCreate() {
    this.toggleNewBuyer(false)
    this.queryTarget.classList.remove("hidden")
    this.queryTarget.focus()
    this.search()
  }

  clear() {
    this.buyerIdTarget.value = ""
    this.selectedTarget.classList.add("hidden")
    this.queryTarget.classList.remove("hidden")
    this.queryTarget.value = ""
    this.queryTarget.focus()
  }

  clearResults() {
    // Dropping src lets the same query reload the results after "Change"
    this.resultsTarget.removeAttribute("src")
    this.resultsTarget.innerHTML = ""
  }

  create() {
    this.buyerIdTarget.value = ""
    this.queryTarget.classList.add("hidden")
    this.clearResults()
    this.toggleNewBuyer(true)
    this.newBuyerNameTarget.value = this.queryTarget.value.trim()
    this.newBuyerNameTarget.focus()
  }

  search = debounce(() => {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("query", this.queryTarget.value)
    this.resultsTarget.src = url.toString()
  }, 250)

  select({ params: { id, name } }) {
    this.buyerIdTarget.value = id
    this.selectedNameTarget.textContent = name
    this.selectedTarget.classList.remove("hidden")
    this.queryTarget.classList.add("hidden")
    this.clearResults()
  }

  // Hidden buyer fields must not be submitted when selecting an existing buyer.
  toggleNewBuyer(show) {
    this.newBuyerTarget.disabled = !show
    this.newBuyerTarget.classList.toggle("hidden", !show)
  }
}
